// extracted by mini-css-extract-plugin
module.exports = {"series-info-container":"style_series-info-container__1ONPx","series-info-wound-type":"style_series-info-wound-type__1AJkD","series-info":"style_series-info__2YOcK"};